export const COUNTRIES = [
  { code: 'NG', name: 'Nigeria', currency: 'NGN', currencySymbol: '₦' },
  { code: 'GH', name: 'Ghana', currency: 'GHS', currencySymbol: '₵' },
  { code: 'US', name: 'United States', currency: 'USD', currencySymbol: '$' },
  { code: 'GB', name: 'United Kingdom', currency: 'GBP', currencySymbol: '£' },
  { code: 'CA', name: 'Canada', currency: 'CAD', currencySymbol: '$' },
];

export const DRAW_SCHEDULES = [
  { value: 'ONE_TIME', label: 'One Time' },
  { value: 'DAILY', label: 'Daily' },
  { value: 'WEEKLY', label: 'Weekly' },
  { value: 'MONTHLY', label: 'Monthly' },
  { value: 'YEARLY', label: 'Yearly' },
];

export const PARTICIPATION_ACCESS = [
  { value: 'OPEN', label: 'Open to Anyone' },
  { value: 'INVITE_EMAIL', label: 'Invite Only (Email)' },
  { value: 'INVITE_CODE', label: 'Invite Only (ID & Access Code)' },
];

export const RAFFLE_STATUS_LABELS = {
  PENDING_START: 'Pending Start',
  ACTIVE: 'Active',
  PAUSED: 'Paused',
  CLOSED: 'Closed',
  ENDED: 'Ended',
};

export const RAFFLE_STATUS_COLORS = {
  PENDING_START: 'warning',
  ACTIVE: 'success',
  PAUSED: 'warning',
  CLOSED: 'danger',
  ENDED: 'default',
} as const;

export const PAYMENT_PROVIDERS = [
  { value: 'WALLET', label: 'Wallet Balance' },
  { value: 'PAYSTACK', label: 'Paystack' },
  { value: 'STRIPE', label: 'Stripe' },
  { value: 'PAYPAL', label: 'PayPal' },
];

export const PAYOUT_METHODS = [
  { value: 'BANK_TRANSFER', label: 'Bank Transfer' },
  { value: 'PAYPAL', label: 'PayPal' },
];

export const TRANSACTION_TYPES = {
  DEPOSIT: 'Deposit',
  WITHDRAWAL: 'Withdrawal',
  PURCHASE: 'Ticket Purchase',
  REFUND: 'Refund',
  WINNING: 'Prize Winning',
  COMMISSION: 'Affiliate Commission',
};

export const WITHDRAWAL_STATUS_LABELS = {
  PENDING: 'Pending',
  PROCESSING: 'Processing',
  COMPLETED: 'Completed',
  FAILED: 'Failed',
  CANCELLED: 'Cancelled',
};

export const WITHDRAWAL_STATUS_COLORS = {
  PENDING: 'warning',
  PROCESSING: 'info',
  COMPLETED: 'success',
  FAILED: 'danger',
  CANCELLED: 'default',
} as const;
